import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function Card({
  children,
  className = '',
  title,
  subtitle,
  actions,
}: CardProps) {
  return (
    <div className={`bg-white rounded shadow-card ${className}`}>
      {(title || subtitle || actions) && (
        <div className="px-[25px] py-4 border-b border-border-light flex items-center justify-between">
          <div>
            {title && (
              <h2 className="text-xl font-semibold text-dark-text pb-[15px]">{title}</h2>
            )}
            {subtitle && (
              <p className="text-sm text-gray-300 mt-1">{subtitle}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className="p-[25px]">{children}</div>
    </div>
  );
}
